// Module
var code = "<div *ngIf=\"text\" class=\"alert alert-danger\"> {{text}} </div>";
// Exports
module.exports = code;